import { Dispatch, ThunkAction } from '../../../../types/actions';
import { THintKey } from '../types';
import { hintActionSetAction } from '../store/hints/actions/hintActionSetAction';
import { hintStatusSetAction } from '../store/hint/actions/hintStatusSetAction';
import { EHintStatus } from '../constants';
import { hintSave } from './hintSave';

export const resetHint = (
    key: THintKey
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
    ) => {
        dispatch(hintActionSetAction(key, hintStatusSetAction(EHintStatus.NOT_SHOWN)));
        dispatch(hintSave(key));
    };
    return action;
};
